import { Store } from '@ngrx/store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UserPageService } from './user-page.service';

@Component({
  selector: 'app-user-page',
  templateUrl: './user-page.component.html',
  styleUrls: ['./user-page.component.scss']
})
export class UserPageComponent implements OnInit, OnDestroy {

  employeeCompany;
  dirtyFormList = {
    form1Dirty: false,
    form2Dirty: false,
    form3Dirty: false,
  };
  // backUrl;
  previousUrl: string;
  isStepperVisible: boolean;

  constructor(
    private userPageService: UserPageService,
    private router: Router,
    private store: Store<any>
  ) {
    if(sessionStorage.getItem('userTypeRole')=='Attorney' && sessionStorage.getItem('selectedCompanyName')){
      this.isStepperVisible = false;
    } else {
      this.isStepperVisible = true;
    }
    this.previousUrl = sessionStorage.getItem('clientCompanyId');
    // this.backUrl = this.router.getCurrentNavigation().extras.state.clientId ?
    //   '../users/' + parseInt(this.router.getCurrentNavigation().extras.state.clientId) : '../users';

  }

  handleCompanySelection(selectedCompany) {
    this.employeeCompany = selectedCompany;
  }

  selectionChange(event) {
    console.log(event.selectedIndex);
    if (this.userPageService.formChangesSubscription) {
      this.userPageService.formChangesSubscription.unsubscribe();
    }
    this.userPageService.statusChangeSubScriptionSubjectStep.next(event.selectedIndex + 1);
  }

  ngOnInit() {
    this.userPageService.statusChangeSubScriptionSubjectStep.next(1);
    this.userPageService.formIsDirtySubject.subscribe(response => {
      switch (response.formNumber) {
        case 1:
          this.dirtyFormList.form1Dirty = response.dirty;
          break;
        case 2:
          this.dirtyFormList.form2Dirty = response.dirty;
          break;
        case 3:
          this.dirtyFormList.form3Dirty = response.dirty;
          break;
      }
      if (!this.dirtyFormList.form1Dirty &&
        !this.dirtyFormList.form2Dirty &&
        !this.dirtyFormList.form3Dirty) {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
      } else {
        this.store.dispatch(new MarkDirtyFormAction({ dirty: true }));
      }
    });
  }

  onBack() {
    this.router.navigateByUrl(this.previousUrl);
  }

  onAttoneySaveBack() {
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    this.router.navigateByUrl(this.previousUrl);
  }

  ngOnDestroy() {
    if (this.userPageService.formChangesSubscription) {
      this.userPageService.formChangesSubscription.unsubscribe();
    }
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }


}
